import { TextInput } from '@mantine/core';
import { IFormInputSpecText } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Preview for a text input.
 */
export default function TextInputPreview({ spec }: { spec: IFormInputSpecText }) {
  return <TextInput required={spec.required} readOnly={spec.readOnly} size="sm" />;
}
